/* eslint-disable no-unused-vars */
import { memo, useState } from 'react';
import { ErrorComponent } from 'components';
import { ContentItem } from '../contentItem/ContentItem';
import styled from 'styled-components';
import { Palette } from 'config';
import { Virtuoso } from 'react-virtuoso';
import { uniqueField } from 'constants';

export const Content = ({
  isError,
  // allCountries,
  itemsToDisplay$,
  onChangeMonthlyBudget,
  searchValue,
  handleChangeIsEdit,
  virtuosoErrorMsgRef,
  indexErrorItems$,
  onUpdateGeoBudgetItems,
  onUpdateIsOpenBudget,
  onUpdateIsAgency,
  onUpdateIsBudgetPerGeo,
}) => {
  return (
    <>
      {isError ? (
        <ErrorComponent style={{ height: '432px' }} />
      ) : (
        <MyVirtuoso
          // isScrolling={setIsScrolling}
          style={{
            height: '432px',
            overflowY: 'scroll',
            paddingLeft: '24px',
            overflowX: 'hidden',
            paddingBottom: '24px',
          }}
          ref={virtuosoErrorMsgRef}
          data={itemsToDisplay$.value}
          itemContent={(index, itemData) => {
            const uniqueId = itemData[uniqueField];
            return (
              <ContentItem
                // isScrolling={isScrolling}
                key={itemData.pbaName}
                index={index}
                // allCountries={allCountries}
                indexErrorItems$={indexErrorItems$}
                handleChangeIsEdit={handleChangeIsEdit}
                isFirstElement={index === 0}
                isLastElement={itemsToDisplay$.value.length - 1 === index}
                {...itemData}
                uniqueId={uniqueId}
                onChangeMonthlyBudget={onChangeMonthlyBudget}
                searchValue={searchValue}
                onUpdateGeoBudgetItems={onUpdateGeoBudgetItems}
                onUpdateIsOpenBudget={onUpdateIsOpenBudget}
                onUpdateIsAgency={onUpdateIsAgency}
                onUpdateIsBudgetPerGeo={onUpdateIsBudgetPerGeo}
              />
            );
          }}
        />
      )}
    </>
  );
};
Content.displayName = 'Content';

const MyVirtuoso = styled(Virtuoso)`
  background: ${Palette.PrimaryGray._100};
  ::-webkit-scrollbar {
    width: 6px;
    background-color: #f1f5f9;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #cbd5e1;
    border-radius: 8px;
  }
`;
